// @flow
import React from 'react';
import styled, { css } from 'styled-components';
import * as _ from "lodash";
import { connect } from "react-redux";
import type { TPlayersById } from '../../modules/types';
import colors from '../../assets/css/colors';
import { below } from '../../assets/css/media';
import {
	TwoColumnLayoutWithSidebarWidgets,
	TopBar,
	AdsContainer,
	Ad,
	WaiverOrderWidget,
	PageTitle,
	JsonFetcher,
	TradeFromUser,
	TradeToUser,
	TradeProposed,
	TradeCompleted,
	TradeRFA,
	CountdownTimer,
	Tabs,
	TabItem,
	ButtonPrimary,
	ButtonSecondary,
	PlayerTableCell,
	ModalContainer,
	ModalInnerTitle,
	BorderedIcon,
	TradeInCell,
	TradeOutCell
} from '../../components';
import Trade from '../../components/Icons/Trade';
import Bell from '../../components/Icons/Bell';
import * as selectors from "../../modules/selectors";
import type {
	TRootStore
} from "../../modules/types";
import * as actions from "../../modules/actions";
import TransactionHistory from './transactions/transactionHistory';
import TransactionSectionsWrapper from './transactions/transactionSectionsWrapper';
import TransactionSectionTitle from './transactions/transactionSectionTitle';
// import type { TPlayersById } from '../../modules/types';

type Props = {
	showDraftLeague: typeof actions.leagueDraft.showDraftLeague,
	fetchTrades: typeof actions.teamsDraft.fetchTrades,
	fetchRejectTrade: typeof actions.teamsDraft.fetchRejectTrade,
	fetchAcceptTrade: typeof actions.teamsDraft.fetchAcceptTrade,
	fetchBlockTrade: typeof actions.teamsDraft.fetchBlockTrade,
	fetchApproveTrade: typeof actions.teamsDraft.fetchApproveTrade,
	fetchWaiverRequests: typeof actions.leagueDraft.fetchWaiverRequests,
	fetchRemoveWaiverTrade: typeof actions.teamsDraft.fetchRemoveWaiverTrade,
	postOrderWaiverTrade: typeof actions.teamsDraft.postOrderWaiverTrade,
	is_rfa_order_saving: boolean,
	ordered_player_ids: Array<number>,
	user_id: number,
	match: Object,
	league: Object,
	players_by_id: TPlayersById,
	trades: {
		completed: Array<Object>,
		my: Array<Object>,
		offer: Array<Object>,
		proposed: Array<Object>
	},
	waiver_requests: {
		by_id: Object,
		ordered_ids: Array<number>
	},
	waiver_requests_by_team_id: Object,
	trade: Object,
	rejectTrade: Function,
	acceptTrade: Function,
	trade_error: boolean | string,
	clearTradeErrors: typeof actions.teamsDraft.clearTeamErrors
}

type State = {
	rfa_order_widget_open: boolean,
	show_trade_confirm_modal: boolean,
	trade_id: number,
	active_tab: string,
	new_player_id: Array<number>,
	old_player_id: Array<number>,
	new_team_name: string,

};

const TransactionTabItems = styled(TabItem)`
	display: inline-block;
	padding-top: 10px;
	width: 50%;
`;

const WhiteDiv = styled.div`
	background-color: white;
`;


const TradeTitleWrapper = styled.div`
	height: 60px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 20px;
	border: 1px solid #F6F6F6;
`;
const TradeTitleStyled = styled.h3`
	font-size: 12px;
	font-weight: 900;
	color: ${colors.nrlDarkGreen};
`;
const TradeTitleTimer = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	svg {
		margin-left: 1em;
	}
`;

const ButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 1em 0;
	button {
		width: 200px;
		margin: 0 .5em;
	}
`;

const StyledTabs = styled(Tabs)`
	height: 60px;
`;

const BorderedIconStyled = styled(BorderedIcon)`
	font-size: 2em;
`;

const ConfirmModalContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 1em 2em 40px;
	${below.desktop`
		${css`
			margin: 1em 0;
		`}
	`}
`;
const TradeCells = styled.div`
	box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
	flex-basis: 40%;
	${below.desktop`
		flex-basis: 50%;
	`}
	> div {
		margin-bottom: 10px;
		&:last-child {
			margin-bottom: 0;
		}
		${below.desktop`
			${css`
				width: 100%;
			`}
		`}

	}
	${below.desktop`
		${css`
			${PlayerTableCell} {
				min-width: 100px;
				flex-basis: 100%;
			}
		`}
	`}
`;

const TradeTitle = ({ is_rfa, unblock_at, onTimerComplete }) => {
	const title = is_rfa ? 'RFA REQUEST' : 'TEAM TO TEAM TRADE';
	return (
		<TradeTitleWrapper>
			<TradeTitleStyled>
				{title}
			</TradeTitleStyled>
			<TradeTitleTimer>
				{unblock_at ? (
					<CountdownTimer
						is_uppercase
						date={unblock_at}
						onComplete={onTimerComplete}
					/> ) : null}
				<Bell color={colors.nrlGreen} size={1.6} />
			</TradeTitleTimer>
		</TradeTitleWrapper>
	);
};


class TransactionsPage extends React.Component<Props, State> {

	state = {
		rfa_order_widget_open: false,
		show_trade_confirm_modal: false,
		trade_id: 0,
		active_tab: 'active',
		new_player_id: [],
		old_player_id: [],
		new_team_name: '',
	};

	static defaultProps = {
	};


	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'onToggleWaiverOrderWidget',
			'getMyTrade',
			'getProposedTrade',
			'getCompletedTrade',
			'getWaiver',
			'rejectTrade',
			'acceptTrade',
			'blockTrade',
			'approveTrade',
			'removeWaiver',
			'onTimerComplete',
			'onChangeRequestsOrder',
			'updateRequestsOrder',
			'handleTradeConfirmModal',
			'setActiveTab',
			'handleErrorModalClose'
		]);
	}

	componentDidMount() {
		const {
			showDraftLeague,
			fetchTrades,
			fetchWaiverRequests,
			match: { params: { league_id, history } },
		} = this.props;

		showDraftLeague({ id: league_id });
		fetchTrades({ league_id });
		fetchWaiverRequests({ league_id });
		if (history === 'history') {
			this.setState({
				active_tab: 'history'
			});
		}
	}


	// Blocks
	get trade_offers() {
		const { trades } = this.props;
		const { my } = trades;
		const my_without_accepted = my ? my.filter(trade => trade.status !== 'accepted') : my;

		if (!_.size(my_without_accepted)) {
			return null;
		}

		return my_without_accepted.map(this.getMyTrade);
	}

	get trade_propose() {
		const { trades } = this.props;
		const { proposed, my } = trades;
		const accepted =  my ? my.filter(trade => trade['status'] === 'accepted') : null;

		const proposed_and_progress = accepted ? proposed.concat(accepted) : proposed;

		if (!_.size(proposed_and_progress)) {
			return null;
		}

		return proposed_and_progress.map(this.getProposedTrade);
	}

	get waivers() {
		const { waiver_requests, league, waiver_requests_by_team_id } = this.props;
		const { ordered_ids } = waiver_requests;
		const { rfa_privacy, team_id } = league;
		if (!_.size(ordered_ids)) {
			return null;
		}

		if (rfa_privacy === 'private') {
			return waiver_requests_by_team_id[team_id].map(this.getWaiver);
		}
		else {
			return _.map(waiver_requests_by_team_id, trades => trades.map(this.getWaiver));
		}

		// return ordered_ids.map(this.getWaiver);
	}

	get trade_complete() {
		const { trades } = this.props;
		const { completed } = trades;
		const completed_trades =
			completed ? completed
				.filter(trade => trade['status'] === 'completed') : completed;

		if (!_.size(completed_trades)) {
			return null;
		}

		return completed_trades.map(this.getCompletedTrade);
	}

	getMyTrade(trade) {
		const { user_id, players_by_id } = this.props;
		const { id, author, unblock_at } = trade;
		const is_user_trade = user_id === author;
		return (
			<div key={id}>
				<TradeTitle
					is_rfa={false}
					unblock_at={unblock_at}
					onTimerComplete={this.onTimerComplete}
				/>
				{ is_user_trade ? (
					<TradeFromUser
						rejectTrade={this.rejectTrade}
						trade={trade}
						players_by_id={players_by_id}
					/>
				) : (
					<TradeToUser
						acceptTrade={this.acceptTrade}
						handleTradeConfirmModal={this.handleTradeConfirmModal}
						rejectTrade={this.rejectTrade}
						trade={trade}
						players_by_id={players_by_id}
					/>
				) }
			</div>
		);
	}

	getProposedTrade(trade) {
		const { players_by_id, user_id } = this.props;
		const { id, unblock_at } = trade;
		return (
			<div key={id}>
				<TradeTitle
					is_rfa={false}
					unblock_at={unblock_at}
					onTimerComplete={this.onTimerComplete}
				/>
				<TradeProposed
					approveTrade={this.approveTrade}
					blockTrade={this.blockTrade}
					trade={trade}
					players_by_id={players_by_id}
					user_id={user_id}
				/>
			</div>
		);
	}

	getCompletedTrade(trade) {
		const { players_by_id } = this.props;
		return (
			<div key={trade.id}>
				<TradeCompleted
					trade={trade}
					players_by_id={players_by_id}
				/>
			</div>
		);
	}

	getWaiver(trade, index) {
		const {
			waiver_requests: { ordered_ids }, players_by_id, is_rfa_order_saving, league
		} = this.props;
		const { team_id } = league;

		// const trade = by_id[id];
		const { remain } = trade;
		const last = _.size(ordered_ids) - 1;

		return (
			<div key={trade.id}>
				{index === 0 ? (
					<TradeTitle
						is_rfa
						unblock_at={_.toString(new Date(new Date().getTime() + (remain * 1000)))}
						onTimerComplete={this.onTimerComplete}
					/>
				) : null}

				<TradeRFA
					is_rfa_order_saving={is_rfa_order_saving}
					removeWaiver={this.removeWaiver}
					trade={trade}
					is_user={team_id === trade.team_id}
					players_by_id={players_by_id}
					onChangeRequestsOrder={this.onChangeRequestsOrder}
					index={index}
					updateRequestsOrder={this.updateRequestsOrder}
					last={last}
				/>
			</div>
		);
	}

	//Handlers
	onToggleWaiverOrderWidget() {
		this.setState(state => ({
			rfa_order_widget_open: !state.rfa_order_widget_open
		}));
	}

	acceptTrade({ trade_id }) {
		const {
			fetchAcceptTrade,
			match: {
				params: { league_id },
			},
			trades
		} = this.props;
		fetchAcceptTrade({ trade_id, league_id, trades });
		this.setState( state => ({
			show_trade_confirm_modal: !state.show_trade_confirm_modal,
		}));
	}
	rejectTrade({ trade_id }) {
		const {
			fetchRejectTrade,
			match: {
				params: { league_id },
			},
			trades
		} = this.props;

		 fetchRejectTrade({ trade_id, league_id, trades });
		
		// this.setState( state => ({
		// 	show_trade_confirm_modal: !state.show_trade_confirm_modal,
		// }));
	}
	blockTrade({ trade_id }) {
		const {
			fetchBlockTrade,
			trades
		} = this.props;

		fetchBlockTrade({ trade_id, trades });
	}
	approveTrade({ trade_id }) {
		const {
			fetchApproveTrade,
			trades
		} = this.props;

		fetchApproveTrade({ trade_id, trades });
	}
	removeWaiver({ trade_id }) {
		const {
			fetchRemoveWaiverTrade
		} = this.props;

		fetchRemoveWaiverTrade({ id: trade_id });
	}
	onTimerComplete() {
		const { fetchTrades, match: { params: { league_id } } } = this.props;
		fetchTrades({ league_id });
	}

	onChangeRequestsOrder({ currentTarget }) {
		const { id } = currentTarget.dataset;
		const order = currentTarget.value;
		const new_order = parseInt(order, 10);
		if (!_.isFinite(new_order)) {
			return;
		}
		this.updateRequestsOrder({
			id: parseInt(id, 10),
			order: new_order
		});
	}
	updateRequestsOrder({ id, order }) {
		const { postOrderWaiverTrade } = this.props;
		postOrderWaiverTrade({ id, position: order });
	}
	setActiveTab({ currentTarget }) {
		const { tab } = currentTarget.dataset;
		const { active_tab } = this.state;
		if (active_tab !== tab) {
			this.setState({
				active_tab: tab
			});
		}
	}

	tradeConfirmModal() {
		const { players_by_id } = this.props;
		const {
			trade_id,
			new_player_id,
			old_player_id
		} = this.state;

		return (
			<ModalContainer header_text="CONFIRM OFFER" onClick={this.handleTradeConfirmModal}>
				<ModalInnerTitle>
					Please revise and confirm the following offer:
				</ModalInnerTitle>
				<ConfirmModalContent>
					<TradeCells>
						{new_player_id.map(id =>
							(<TradeInCell key={id} player={players_by_id[id]} />))}
					</TradeCells>
					<BorderedIconStyled background='#fff' className="hidden-mobile" >
						<Trade size="2" />
					</BorderedIconStyled>
					<TradeCells>
						{old_player_id.map(id =>
							(<TradeOutCell key={id} player={players_by_id[id]} />))}
					</TradeCells>
				</ConfirmModalContent>
				<ButtonsWrapper>
					<ButtonSecondary onClick={() => this.rejectTrade({ trade_id })}>
						REJECT OFFER
					</ButtonSecondary>
					<ButtonPrimary
						onClick={() => this.acceptTrade({ trade_id })}
					>
						CONFIRM OFFER
					</ButtonPrimary>
				</ButtonsWrapper>

			</ModalContainer>
		);
	}

	handleTradeConfirmModal(trade) {
		this.setState( state => ({
			show_trade_confirm_modal: !state.show_trade_confirm_modal,
			trade_id: trade.id,
			new_player_id: trade.new_player_id,
			old_player_id: trade.old_player_id,
			new_team_name: trade.new_team_name,

		}));
	}

	handleErrorModalClose() {
		const { clearTradeErrors } = this.props;
		clearTradeErrors();
	}

	get transactions_section() {
		const { trades, waiver_requests } = this.props;
		const { my, proposed } = trades;
		const { ordered_ids } = waiver_requests;
		const accepted =  my ? my.filter(trade => trade['status'] === 'accepted') : null;

		const proposed_and_progress = accepted ? proposed.concat(accepted) : proposed;
		return (
			<TransactionSectionsWrapper>
				<TransactionSectionTitle>
					{_.size(ordered_ids) ?
						'Your Restricted Free Agent (RFA) Requests' :
						'You have no RFA requests'
					}
				</TransactionSectionTitle>
				{this.waivers}
				<TransactionSectionTitle>
					{_.size(my) ?
						'Your Trade Offers' :
						'You have no pending trades'
					}
				</TransactionSectionTitle>
				{this.trade_offers}
				<TransactionSectionTitle>
					{_.size(proposed_and_progress) ?
						'Pending Trades' :
						'There are no pending trades'
					}
				</TransactionSectionTitle>
				{this.trade_propose}
			</TransactionSectionsWrapper>
		);
	}

	get history_section() {
		const {
			match: { params: { league_id } }
		} = this.props;
		return <TransactionHistory league_id={league_id} />;
	}

	get error_modal() {
		const { trade_error } = this.props;
		if(!trade_error){
			return null;
		}
		console.log(trade_error, 'error');
		return (
			<ModalContainer header_text="Error" onClick={this.handleErrorModalClose}>
				<ModalInnerTitle>
					{trade_error}
				</ModalInnerTitle>
			</ModalContainer>
		);
	}

	render() {
		const { league, ordered_player_ids  } = this.props;
		const { rfa_order_widget_open, show_trade_confirm_modal } = this.state;
		const { active_tab } = this.state;
		const is_history_tab = active_tab === 'history';
		const data_array = ['rounds', 'players', 'squads', 'venues', 'coach_players', 'show_teams'];
		console.log("props",this.props,this.state);
		return (
			<div>
				{this.error_modal}
				<JsonFetcher fetch={data_array} />
				<TopBar league={league} />
				<AdsContainer>
					<Ad
						adUnit='myleagues/transactions'
						size='top'
					/>
				</AdsContainer>
				<TwoColumnLayoutWithSidebarWidgets sidebar_open={rfa_order_widget_open}>
					<div>
						<PageTitle>
							Transactions for {league.name}
						</PageTitle>
						<WhiteDiv>
							{ !_.isEmpty( ordered_player_ids) &&
							<StyledTabs>
								<TransactionTabItems
									onClick={this.setActiveTab}
									data-tab="active"
									className={!is_history_tab ? 'active-tab' : ''}>
									Your Active Transactions
								</TransactionTabItems>
								<TransactionTabItems
									onClick={this.setActiveTab}
									data-tab="history"
									className={is_history_tab ? 'active-tab' : ''}>
									Transaction History
								</TransactionTabItems>
							</StyledTabs>
							}
							{is_history_tab ? this.history_section : this.transactions_section}
							{show_trade_confirm_modal && this.tradeConfirmModal()}
						</WhiteDiv>
					</div>
					<div className="hidden-mobile">
						{league.id ? (
							<WaiverOrderWidget
								league_id={league.id}
								onToggle={ this.onToggleWaiverOrderWidget }
								widget_open={this.state.rfa_order_widget_open}
							/>
						) : null }
					</div>
				</TwoColumnLayoutWithSidebarWidgets>
				<AdsContainer>
					<Ad
						adUnit='myleagues/transactions'
						size='bottom'
					/>
				</AdsContainer>
			</div>
		);
	}
}

const mapStateToProps = (state: TRootStore, props) => ({
	selected_league_id: props.match.params.league_id,
	league: selectors.leagueDraft.getLeague(state, props),
	user_id: state.user.data.id,
	trades: state.teamsDraft.trades,
	players_by_id: selectors.players.getExtendedPlayersById(state),
	waiver_requests: state.leagues.waiver_requests,
	waiver_requests_by_team_id: selectors.leagueDraft.getWaiverRequestsByTeamId(state),
	is_rfa_order_saving: state.teamsDraft.is_rfa_order_saving,
	ordered_player_ids: state.players.ordered_ids,
	trade_error: state.teamsDraft.error
});

const mapDispatchToProps = {
	showDraftLeague: actions.leagueDraft.showDraftLeague,
	fetchTrades: actions.teamsDraft.fetchTrades,
	fetchRejectTrade: actions.teamsDraft.fetchRejectTrade,
	fetchAcceptTrade: actions.teamsDraft.fetchAcceptTrade,
	fetchBlockTrade: actions.teamsDraft.fetchBlockTrade,
	fetchApproveTrade: actions.teamsDraft.fetchApproveTrade,
	fetchWaiverRequests: actions.leagueDraft.fetchWaiverRequests,
	fetchRemoveWaiverTrade: actions.teamsDraft.fetchRemoveWaiverTrade,
	postOrderWaiverTrade: actions.teamsDraft.postOrderWaiverTrade,
	clearTradeErrors: actions.teamsDraft.clearTeamErrors
};

export const Transactions = connect(
	mapStateToProps,
	mapDispatchToProps,
)(TransactionsPage);

export default Transactions;


// WEBPACK FOOTER //
// ./src/pages/league/Transacitions.js